import { Directive, Input } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { UtilityService } from './../providers/utility.service';

@Directive({ selector: '[hasPermission]' })
export class ComponentPermissionDirective {
  permissionJson: any;
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private service: UtilityService
  ) { }

  @Input() set hasPermission(role: string) {
    let negatePermission = false; // negate logic added to handle a scenario in addp.
    let hasPerm;
    if (role && role.indexOf('!') > - 1) {
      negatePermission = true;
      const splitted = role.split('!');
      if (splitted && splitted.length > 0) {
        role = splitted[1];
      }
    }
    if (sessionStorage.getItem('permissions') != null) {
      this.permissionJson = JSON.parse(sessionStorage.getItem('permissions'));
      hasPerm = this.service.checkComponentPermission(role, this.permissionJson.perm);
      hasPerm = negatePermission ? !hasPerm : hasPerm;
      if (hasPerm) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
